import antigravityLogo from './assets/antigravity.png'
import chatgptLogo from './assets/chatgpt.png'
import claudeLogo from './assets/claude.png'
import cursorLogo from './assets/cursor.png'
import grokLogo from './assets/grok.png'
import manusLogo from './assets/manus.png'
import mcpLogo from './assets/mcp.png'
import n8nLogo from './assets/n8n.png'
import notionLogo from './assets/notion.png'
import perplexityLogo from './assets/perplexity.png'
import raycastLogo from './assets/raycast.png'
import zapierLogo from './assets/zapier.png'
import type { Integration } from './types'

export const INTEGRATIONS: Integration[] = [
  {
    id: 'zapier',
    name: 'Zapier',
    description: 'Automate workflows with Zapier',
    clientNamePrefixes: ['zapier'],
    iconLetter: 'Z',
    iconBgColor: 'var(--global-color-orange-400)',
    iconSrc: zapierLogo,
  },
  {
    id: 'claude',
    name: 'Claude',
    description: 'Manage your content from Claude and Claude Code',
    clientNamePrefixes: ['claude'],
    iconLetter: 'C',
    iconBgColor: 'var(--global-color-orange-700)',
    iconSrc: claudeLogo,
  },
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    description: 'Manage your content from ChatGPT and Codex',
    clientNamePrefixes: ['chatgpt', 'codex'],
    iconLetter: 'C',
    iconBgColor: 'var(--global-color-green-600)',
    iconSrc: chatgptLogo,
  },
  {
    id: 'notion',
    name: 'Notion',
    description: 'Manage your content from Notion custom agents',
    clientNamePrefixes: ['notion'],
    iconLetter: 'N',
    iconBgColor: 'var(--global-color-gray-800)',
    iconSrc: notionLogo,
  },
  {
    id: 'manus',
    name: 'Manus',
    description: 'Manage your content from Manus',
    clientNamePrefixes: ['manus'],
    iconLetter: 'M',
    iconBgColor: 'var(--global-color-gray-900)',
    iconSrc: manusLogo,
  },
  {
    id: 'mcp',
    name: 'MCP',
    description: "Using an AI tool we don't list? Connect it with an API key.",
    // The protocol mark identifies no vendor, so clients named after the
    // protocol keep the unmatched fallback rather than claiming this entry.
    clientNamePrefixes: [],
    iconLetter: 'M',
    iconBgColor: 'var(--global-color-gray-800)',
    iconSrc: mcpLogo,
  },
  {
    id: 'grok',
    name: 'Grok',
    description: 'Manage your content from Grok',
    clientNamePrefixes: ['grok'],
    iconLetter: 'G',
    iconBgColor: 'var(--global-color-gray-900)',
    iconSrc: grokLogo,
  },
  {
    id: 'cursor',
    name: 'Cursor',
    description: 'Build and automate from your editor',
    clientNamePrefixes: ['cursor'],
    iconLetter: 'C',
    iconBgColor: 'var(--global-color-blue-500)',
    iconSrc: cursorLogo,
  },
  {
    id: 'antigravity',
    name: 'Antigravity',
    description: "Manage your content from Google's agent-first IDE",
    clientNamePrefixes: ['antigravity'],
    iconLetter: 'A',
    iconBgColor: 'var(--global-color-blue-500)',
    iconSrc: antigravityLogo,
  },
  {
    id: 'n8n',
    name: 'n8n',
    description: 'Workflow automation with n8n',
    clientNamePrefixes: ['n8n'],
    iconLetter: 'n',
    iconBgColor: 'var(--global-color-red-500)',
    iconSrc: n8nLogo,
  },
  {
    id: 'raycast',
    name: 'Raycast',
    description: 'Quick actions from your menu bar',
    clientNamePrefixes: ['raycast'],
    iconLetter: 'R',
    iconBgColor: 'var(--global-color-purple-500)',
    iconSrc: raycastLogo,
  },
  {
    id: 'perplexity',
    name: 'Perplexity',
    description: 'Manage your content from Perplexity Web and Desktop',
    clientNamePrefixes: ['perplexity'],
    iconLetter: 'P',
    iconBgColor: 'var(--global-color-blue-700)',
    iconSrc: perplexityLogo,
  },
]
